import { useQuery, UseQueryOptions } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { ScheduledPostTarget } from 'types'
import { ScheduledPostTargetsClient } from 'api/clients/ScheduledPostTargetsClient'
import { scheduledPostTargetsKeys } from './scheduledPostTargetsKeys'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Data = ScheduledPostTarget

export interface Options<TData = Data> extends UseQueryOptions<Data, unknown, TData> {}

export const fetchScheduledPostTarget = async ({
  workspaceId,
  scheduledPostId,
  targetId,
}: {
  workspaceId: number
  scheduledPostId: number
  targetId: number
}) => {
  const res = await ScheduledPostTargetsClient.show({ workspaceId, scheduledPostId, targetId })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.scheduled_post_target
}

export const useScheduledPostTarget = <TData = Data,>(
  scheduledPostId: number,
  targetId: number,
  options?: Options<TData>,
) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data, unknown, TData>(
    scheduledPostTargetsKeys.detail(workspaceId, scheduledPostId, targetId),
    () => fetchScheduledPostTarget({ workspaceId, scheduledPostId, targetId }),
    {
      refetchOnWindowFocus: false,
      enabled: !!workspaceId,
      ...options,
    },
  )
}
